"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _InternalPageHeader = _interopRequireDefault(require("web/shared/components/InternalPageHeader"));
var _QueryBoundary = _interopRequireDefault(require("web/shared/relay/QueryBoundary"));
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _consolePage = require("web/shared/console/consolePage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The chrome the performance pages render inside.
*
* Its own, and no other console's. A distribution of timings is its own
* mechanism, and chrome shared with an unrelated console would be a thing
* neither owns and both are afraid to change. What consoles have in common is
* the product's design tokens, which is where a resemblance belongs.
*
* **The loading and failure lines are here, once.** Both views read on
* render and suspend, so the frame holds their content inside a boundary and
* says the two things a reader sees while waiting or after a failure. A view
* that said them itself would be a second wording of the same two states.
*
* There is no view-switching nav here on purpose: the performance console is
* a list and the detail reached from it, and a nav of one entry is a label
* pretending to be navigation.
*/
function PerfFrame(props) {
  var _props$context;
  const title = props.title,
    intro = props.intro,
    onRefresh = props.onRefresh,
    controls = props.controls;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_consolePage.consolePage.inset, _consolePage.consolePage.roomBelow, _perfViewsStyles.styles.page)), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.section)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InternalPageHeader.default, {
        title: title,
        context: (_props$context = props.context) !== null && _props$context !== void 0 ? _props$context : null,
        backTo: props.backTo,
        backLabel: props.backLabel,
        trailing: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.controls)), {}, {
          children: [controls, /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            type: "button",
            onClick: onRefresh
          }, stylex.props(_perfViewsStyles.styles.button)), {}, {
            children: "refresh"
          }))]
        }))
      }), intro != null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.intro)), {}, {
        children: intro
      })) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_QueryBoundary.default, {
        fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
          children: "Loading\u2026"
        })),
        renderError: message => /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.errorText)), {}, {
          children: message
        })),
        resetKey: props.resetKey,
        children: props.children
      })]
    }))
  }));
}
var _default = exports.default = PerfFrame;